export const environment = {
  production: true,
  refereapiurl: 'https://apis.globalhuntindia.com/srcs/',
  siteName: 'https://www.globalhunt.in',
  source: 'RefereeRef',
  redirectUrl: 'https://referee.globalhuntindia.com/',
  domain: '.globalhuntindia.com',
  apiKey: 'wTfMeourQY8ldJMM9VybZ9YEjjFGha3y5fKpg7gc'
};
